import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { open, OpenType } from '@board/open-handler';
import * as Boardtypes from '@board/store/types'
import { mapGetters } from 'vuex';
import menuHelper from '@appbase/util/menu-helper'
import { LoadingBar } from '@appbase/components/loading'


@Component({
    components: { LoadingBar },
})
export default class YWK_MigBoardList extends Vue {
    @Prop({type:Array}) articles!:Array<ywkMigration.article>
    @Prop({type:Number, default : 0 }) total!:Number
    @Prop({type:Boolean, default : false }) isLoading!:Number
}
